export default __webpack_public_path__ + "static/media/N-02.a3ba8507.png";